import { SessionFile } from './session-file';
export class FileHolder {
    public Id: string;
    public File: any;
    public StepNumber: number;
}
